import Box from "ds/components/Box";
import Typography from "ds/components/Typography";
import ChartTooltip from "ds/components/Charts/components/Tooltip";
import ChartTooltipDivider from "ds/components/Charts/components/Tooltip/Divider";

import { WorkerUsageDay } from "../types";
import { formatWorkerUsageDate } from "../utils";

type ConcurrencyChartTooltipProps = {
  day: WorkerUsageDay;
  percentile: number;
  showsBurstMinutes: boolean;
};

const ConcurrencyChartTooltip = ({
  day,
  percentile,
  showsBurstMinutes,
}: ConcurrencyChartTooltipProps) => (
  <ChartTooltip>
    <Typography variant="p-t7" tag="span" color="primary">
      {formatWorkerUsageDate(day.day, "EEE d MMM")}
    </Typography>
    <ChartTooltipDivider />
    <Box direction="column" gap="small">
      <Box direction="row" gap="small">
        <Typography variant="p-t7" tag="span" color="primary">
          Max workers:
        </Typography>
        <Typography variant="p-body3" tag="span" color="primary">
          {day.max}
        </Typography>
      </Box>
      {day.percentileToDateValue !== undefined && (
        <Box direction="row" gap="small">
          <Typography variant="p-t7" tag="span" color="primary">
            P{percentile} workers:
          </Typography>
          <Typography variant="p-body3" tag="span" color="primary">
            {day.percentileToDateValue}
          </Typography>
        </Box>
      )}
      {showsBurstMinutes && day.burstMinutesUsed !== undefined && (
        <Box direction="row" gap="small">
          <Typography variant="p-t7" tag="span" color="primary">
            Burst minutes used:
          </Typography>
          <Typography variant="p-body3" tag="span" color="primary">
            {day.burstMinutesUsed}
          </Typography>
        </Box>
      )}
    </Box>
  </ChartTooltip>
);

ConcurrencyChartTooltip.displayName = "UsageWorkers.ConcurrencyChart.Tooltip";

export default ConcurrencyChartTooltip;
